import { init } from '@makemydeal/activities-request-proposal';
import { APP_NAME } from './constants';
import { additionalSelectors } from './additionalSelectors';
import { hostActions } from './hostActions';

export const configureRequestProposal = () => {
    const { middlewareMgr } = init(APP_NAME, additionalSelectors, hostActions);
    return middlewareMgr;
};
